import {Link} from 'react-router-dom';
import {useParams} from 'react-router-dom';
import {useState,useEffect} from 'react';
import axios from "axios";
import {baseUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'
function StoresMenu(){
    return (
        <section className="container mt-4">
            <div className="row nurseInpatient">
                <div className='col-md-12 col-12'>
                    <div className="row">
                    <div className="col-md-12 company-info">
                    <div className="panel panel-primary">
                    <div className="panel-heading">
                    <h4 className="panel-title" >Stores Master</h4>
                    </div>
                    </div>
                    </div>
                    </div>

                    <div className="row">
                    <div className="col-md-12 company-info">
                    <div className="btn-group">
                    <a href="/add-supplier"><button type="button" className="btn btn"><span >Add Supplier</span></button></a></div>
                    <div className="btn-group">
                    <a href="/add-eqp-cat"><button type="button" className="btn btn"><span >Add Eqp Category</span></button></a></div>
                    <div className="btn-group">
                    <a href="/add-eqp-subcat"><button type="button" className="btn btn"><span >Add Eqp Subcategory</span></button></a></div>
                    <div className="btn-group">
                    <a href="/equip-list"><button type="button" className="btn btn"><span >Equipment List</span></button></a></div>
                    <div className="btn-group">
                    <a href="/eqp-raise-indent"><button type="button" className="btn btn"><span >Raise Indent</span></button></a></div>
                    <div className="btn-group">
                    <a href="/indent-eqp-list"><button type="button" className="btn btn"><span >View Indent</span></button></a></div>
                    </div>
                    </div>

                    <div className="row">
                    <div className="col-md-12 company-info">
                    <div className="panel panel-primary">
                    <div className="panel-heading">
                    <h4 className="panel-title" >Stores Entry</h4>
                    </div>
                    </div>
                    </div>
                    </div>

                    <div className="row">
                    <div className="col-md-12 company-info">
                    <div className="btn-group">
                    <a href="/add-eqp-product"><button type="button" className="btn btn"><span >New Eqp Entry</span></button></a></div>
                    <div className="btn-group">
                    <a href="/eqp-grn-entry"><button type="button" className="btn btn"><span >GRN Entry</span></button></a></div>
                    <div className="btn-group">
                    <a href="/eqp-grn-list"><button type="button" className="btn btn"><span >View GRN</span></button></a></div>
                    <div className="btn-group">
                    <a href="/eqp-po-list"><button type="button" className="btn btn"><span >View PO</span></button></a></div>
                    <div className="btn-group">
                    <a href="/eqp-purchase-return"><button type="button" className="btn btn"><span >Purchase Return</span></button></a></div>
                    <div className="btn-group">
                    <a href="/supplier-search"><button type="button" className="btn btn"><span >Supplier-wise Payment</span></button></a></div>
                    </div>
                    </div>

                    <div className="row">
                    <div className="col-md-12 company-info">
                    <div className="panel panel-primary">
                    <div className="panel-heading">
                    <h4 className="panel-title" >Stores Reports</h4>
                    </div>
                    </div>
                    </div>
                    </div>

                    <div className="row">
                    <div className="col-md-12 company-info">
                    <div className="btn-group">
                    <a href="/eqp-return-report"><button type="button" className="btn btn"><span >Purchase Return Report</span></button></a></div>
                    <div className="btn-group">
                    <a href="/eqp-gst-report"><button type="button" className="btn btn"><span >Purchase GST Report</span></button></a></div>
                    <div className="btn-group">
                    <a href="/eqp-gst-stat"><button type="button" className="btn btn"><span >Purchase GST Statement</span></button></a></div>
                    </div>
                    </div>


               </div>
            </div>
        </section>
    )
}

export default StoresMenu;